import React, { Suspense, lazy, useEffect } from 'react';
import { Router } from '@reach/router';
import { useSelector } from 'react-redux';

// Components
import Loader from 'components/_utility/Loader/Loader';
import Init from 'components/_utility/Init/Init';
import DummyHeader from 'components/_utility/DummyHeader/DummyHeader';
import { Wrap } from './App.styled';
import ErrorBoundary from './ErrorBoundary';
import { getErrorSelector } from './redux/app/selectors';

// Lazy import components
const Search = lazy(() => import('components/_pages/Search/Search'));
const Dealers = lazy(() => import('components/_pages/Dealers/Dealers'));

const App = ({ contentApiEndpoint, basepath }) => {
  const error = useSelector(getErrorSelector);

  useEffect(() => {
    const mainEl = document.querySelector('.main');

    if (mainEl) {
      mainEl.style.overflowX = 'visible';
    }

    return () => {
      if (mainEl) {
        mainEl.style.overflowX = 'hidden';
      }
    };
  }, []);

  return (
    <Wrap>
      <ErrorBoundary error={error}>
        <Init contentApiEndpoint={contentApiEndpoint} basepath={basepath}>
          {process.env.MODE === 'development' ? <DummyHeader /> : null}
          <Suspense fallback={<Loader />}>
            <Router basepath={basepath}>
              <Search path="/" />
              <Dealers path="/all-dealers" />
            </Router>
          </Suspense>
        </Init>
      </ErrorBoundary>
    </Wrap>
  );
};

export default App;
